var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OvertimeRequestList',{attrs:{"activeTabIndex":1,"title":"Approved","extraRouteQuery":"approved=true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }